import WhatshotRoundedIcon from '@mui/icons-material/WhatshotRounded';
import PostRail from '../shared/PostRail';
import { SectionCard } from '../shared/insightUi';

function PopularPosts({ popular_posts = [] }) {
  const posts = (Array.isArray(popular_posts) ? popular_posts : []).slice(0, 30);
  if (!posts.length) return null;
  return (
    <SectionCard
      icon={<WhatshotRoundedIcon fontSize="small" />}
      title="Popular posts"
      subtitle="Best performing content by engagement"
      bodyPadding="16px 24px 12px"
    >
      <PostRail posts={posts} />
    </SectionCard>
  );
}

export default PopularPosts;
